import React, { useEffect, useState } from "react";
import { Row, Col, Card, Button } from "react-bootstrap";
import Table from "../../components/Table";
import PageTitle from "../../components/PageTitle";
import api from "../../utils/ApiMethod";
import { downloadExcel } from "react-export-table-to-excel";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import AddMarksModal from "./AddMarksModal";
import UpdateMarks from "./UpdateMarks";
// import UpdateMarks from "./UpdateMarks";

interface UGMergedStudentMarksData {
  _id: string;
  course_name: string;
  form_no: string | null;
  enrollment_no: string;
  session: string;
  admission_date: string;
  roll_number: string;
  rank: string;
  first_name: string;
  middle_name: string;
  last_name: string;
  dob: string;
  category: string;
  category_selected: string;
  gender: string;
  nationality: string;
  religion: string;
  student_mobile: string;
  email: string;
  aiims_email: string;
  identification_mark: string;
  std_bloodgrp: string;
  father_name: string;
  mother_name: string;
  student_image: string | null;
  sign_image: string | null;
  admission_letter: string | null;
  corr_stateName: string;
  corr_districtName: string;
  corr_town: string;
  corr_police_station: string;
  corr_post_office: string;
  corr_street_address: string;
  corr_pin: string;
  corr_landline: string;
  corr_mobile: string;
  corr_email: string;
  perm_stateName: string;
  perm_districtName: string;
  perm_town: string;
  perm_police_station: string;
  perm_post_office: string;
  perm_street_address: string;
  perm_pin: string;
  perm_landline: string;
  perm_mobile: string;
  perm_email: string;
  gardi_fname: string;
  gard_lname: string;
  gard_mobile: string;
  guardian_email: string;
  relation: string;
  gardian_address: string;
  school_name: string;
  school_state: string;
  school_city: string;
  school_board: string;
  pass_year: string;
  school_marks: string;
  marks_obtained: string;
  schoolMarksInPercentage: string;
  school_cgpa: string;
  school_division: string;
  schoolname_ten_plus_two: string;
  state_Name_ten_plus_two: string;
  city_ten_plus_two: string;
  board_ten_plus_two: string;
  passyear_ten_plus_two: string;
  marks_ten_plus_two: string;
  marks_ten_plus_two_obtained: string;
  tenPlusTwoMarksInPercentage: string;
  cgpa_ten_plus_two: string;
  division_ten_plus_two: string;
  MedicalRegistration: string;
  RegisrationState: string;
  Registration: string;
  isDetailsUpdated: string;
  status: string;
  rejectionReason: string;
  same_addr: boolean;
  //   approvedby: string | null;
  //   update_date: string | null;
  updated_by: string;
  //  attendanceRecord: {
  studentId: String;
  // session: String;
  courseName: String;
  examName: String;
  subjectName: String;
  studentName: String;
  // enrollment_no: String;
  totalTheoryMarks: Number;
  obtainedTheoryMarks: Number;
  totalPracticalMarks: Number;
  obtainedPracticalMarks: Number;
  percentage: Number;
  // };
}
interface UGStudentData {
  id: string;
  course_name: string;
  form_no: string | null;
  enrollment_no: string;
  session: string;
  admission_date: string;
  roll_number: string;
  rank: string;
  first_name: string;
  middle_name: string;
  last_name: string;
  dob: string;
  category: string;
  category_selected: string;
  gender: string;
  nationality: string;
  religion: string;
  student_mobile: string;
  email: string;
  aiims_email: string;
  identification_mark: string;
  std_bloodgrp: string;
  father_name: string;
  mother_name: string;
  student_image: string | null;
  sign_image: string | null;
  admission_letter: string | null;
  corr_stateName: string;
  corr_districtName: string;
  corr_town: string;
  corr_police_station: string;
  corr_post_office: string;
  corr_street_address: string;
  corr_pin: string;
  corr_landline: string;
  corr_mobile: string;
  corr_email: string;
  perm_stateName: string;
  perm_districtName: string;
  perm_town: string;
  perm_police_station: string;
  perm_post_office: string;
  perm_street_address: string;
  perm_pin: string;
  perm_landline: string;
  perm_mobile: string;
  perm_email: string;
  gardi_fname: string;
  gard_lname: string;
  gard_mobile: string;
  guardian_email: string;
  relation: string;
  gardian_address: string;
  school_name: string;
  school_state: string;
  school_city: string;
  school_board: string;
  pass_year: string;
  school_marks: string;
  marks_obtained: string;
  schoolMarksInPercentage: string;
  school_cgpa: string;
  school_division: string;
  schoolname_ten_plus_two: string;
  state_Name_ten_plus_two: string;
  city_ten_plus_two: string;
  board_ten_plus_two: string;
  passyear_ten_plus_two: string;
  marks_ten_plus_two: string;
  marks_ten_plus_two_obtained: string;
  tenPlusTwoMarksInPercentage: string;
  cgpa_ten_plus_two: string;
  division_ten_plus_two: string;
  MedicalRegistration: string;
  RegisrationState: string;
  PGRegistration: string;
  isDetailsUpdated: string;
  status: string;
  rejectionReason: string;
  same_addr: boolean;
  //   approvedby: string | null;
  //   update_date: string | null;
  updated_by: string;
}
interface UGMarksData {
  studentId: String;
  session: String;
  courseName: String;
  examName: String;
  subjectName: String;
  studentName: String;
  enrollment_no: String;
  totalTheoryMarks: Number;
  obtainedTheoryMarks: Number;
  totalPracticalMarks: Number;
  obtainedPracticalMarks: Number;
  percentage: Number;
  // attendanceOfMonth: String;
}
// interface UGStudentData {
//   id: string;
//   course_name: string;
//   form_no: string | null;
//   enrollment_no: string;
//   session: string;
//   admission_date: string;
//   roll_number: string;
//   rank: string;
//   first_name: string;
//   middle_name: string;
//   last_name: string;
//   dob: string;
//   category: string;
//   category_selected: string;
//   gender: string;
//   nationality: string;
//   religion: string;
//   student_mobile: string;
//   email: string;
//   aiims_email: string;
//   identification_mark: string;
//   std_bloodgrp: string;
//   father_name: string;
//   mother_name: string;
//   student_image: string | null;
//   sign_image: string | null;
//   admission_letter: string | null;
//   corr_stateName: string;
//   corr_districtName: string;
//   corr_town: string;
//   corr_police_station: string;
//   corr_post_office: string;
//   corr_street_address: string;
//   corr_pin: string;
//   corr_landline: string;
//   corr_mobile: string;
//   corr_email: string;
//   perm_stateName: string;
//   perm_districtName: string;
//   perm_town: string;
//   perm_police_station: string;
//   perm_post_office: string;
//   perm_street_address: string;
//   perm_pin: string;
//   perm_landline: string;
//   perm_mobile: string;
//   perm_email: string;
//   gardi_fname: string;
//   gard_lname: string;
//   gard_mobile: string;
//   guardian_email: string;
//   relation: string;
//   gardian_address: string;
//   school_name: string;
//   school_state: string;
//   school_city: string;
//   school_board: string;
//   pass_year: string;
//   school_marks: string;
//   marks_obtained: string;
//   schoolMarksInPercentage: string;
//   school_cgpa: string;
//   school_division: string;
//   schoolname_ten_plus_two: string;
//   state_Name_ten_plus_two: string;
//   city_ten_plus_two: string;
//   board_ten_plus_two: string;
//   passyear_ten_plus_two: string;
//   marks_ten_plus_two: string;
//   marks_ten_plus_two_obtained: string;
//   tenPlusTwoMarksInPercentage: string;
//   cgpa_ten_plus_two: string;
//   division_ten_plus_two: string;
//   MedicalRegistration: string;
//   RegisrationState: string;
//   PGRegistration: string;
//   isDetailsUpdated: string;
//   status: string;
//   rejectionReason: string;
//   same_addr: boolean;
//   //   approvedby: string | null;
//   //   update_date: string | null;
//   updated_by: string;
// }

interface SessionInfo {
  courseType: string;
  sessionYear: string;
  status: string;
  _id?: string;
}

interface CourseInfo {
  courseType: string;
  courseName: string;
  courseCode: string;
  status: string;
  _id?: string;
}

interface ExamInfo {
  courseType: string;
  courseCode: string;
  examName: string;
  examCode: string;
  _id?: string;
}

interface SubjectInfo {
  courseType: string;
  courseCode: string;
  // examName: string;
  examCode: string;
  subjectName: string;
  subjectCode: string;
  paperType: string;
  _id?: string;
}

const UGMarksheet = () => {
  const [ugStudents, setUGStudents] = useState<UGStudentData[]>([]);
  const [marksData, setMarksData] = useState<UGMarksData[]>([]);
  const [mergedData, setMergedData] = useState<UGMergedStudentMarksData[]>([]);
  const [selectMonth, setSelectedMonth] = useState<any>();
  // const tableRef = useRef<any>(null);
  // const [isOpen, setIsOpen] = useState<any>(false);
  //  console.log(ugStudents, "ugStudents");
  const [dateRange, setDateRange] = useState<any>([
    new Date(),
    new Date().setDate(new Date().getDate() + 7),
  ]);
  const [startDate, endDate] = dateRange;
  const [session, setSession] = useState([]);
  const [selectedSession, setSelectedSession] = useState<number | "">(""); // State to hold the selected year
  const [courses, setCourses] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState("");
  const [isResponse, setIsResponse] = useState("");
  const [exams, setExams] = useState([]);

  const [selectedExam, setSelectedExam] = useState("");

  const [subjects, setSubjects] = useState([]);
  const [selectedSubjects, setSelectedSubjects] = useState("");
  const [file, setFile] = useState<File | null>(null);

  // console.log(selectedSession,selectedCourse,selectedExam,selectedSubjects,"Session Selected","Course Selected", "Exam selected","Subject Selected");
  /*
   * handle date change
   */
  //   const onDateChange = (date: Date) => {
  //     if (date) {
  //       setDateRange(date);
  //     }
  //   };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.fetchData(`/api/all/session`);

        if (response.status !== 200) {
          const errorMsg = await response.json();
          setIsResponse(errorMsg?.message || "Unknown error occurred.");
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        // const data = await response.json(); // Assuming response.data is JSON data
        setSession(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
        setIsResponse("Error fetching courses. Please try again later.");
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // const response = await api.fetchData(`/api/active/course`);
        const response = await api.fetchData(`/api/active/course/ug`);
        if (response.status !== 200) {
          const errorMsg = await response.json();
          setIsResponse(errorMsg?.message || "Unknown error occurred.");
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        // const data = await response.json(); // Assuming response.data is JSON data
        setCourses(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
        setIsResponse("Error fetching courses. Please try again later.");
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (selectedCourse) {
          const response = await api.fetchData(
            `/api/active/exam/byCourseSelected/${selectedCourse}`
          );
          // const response = await api.fetchData(`/api/active/exam`);

          if (response.status !== 200) {
            const errorMsg = await response.json();
            setIsResponse(errorMsg?.message || "Unknown error occurred.");
            throw new Error(`HTTP error! Status: ${response.status}`);
          }

          // const data = await response.json(); // Assuming response.data is JSON data
          setExams(response.data.data);
          // console.log(response.data.data, "response.data");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setIsResponse("Error fetching examination. Please try again later.");
      }
    };

    fetchData();
  }, [selectedCourse]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (selectedExam) {
          const response = await api.fetchData(
            `/api/active/subject/${selectedExam}`
          );
          // const response = await api.fetchData(`/api/active/subject`);

          if (response.status !== 200) {
            const errorMsg = await response.json();
            setIsResponse(errorMsg?.message || "Unknown error occurred.");
            throw new Error(`HTTP error! Status: ${response.status}`);
          }

          // const data = await response.json(); // Assuming response.data is JSON data
          setSubjects(response.data);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setIsResponse("Error fetching examination. Please try again later.");
      }
    };

    fetchData();
  }, [selectedExam]);

  // --------------------------------for fetching student record from ugstudent to add/update marks -----------------------
  // /api/all/ug/student/forAttendance/:selectedSession/:selectedCourse
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (selectedSession && selectedCourse) {
          const response = await api.fetchData(
            `/api/all/ug/student/forAttendance/${selectedSession}/${selectedCourse}`
          );
          if (response.status !== 200) {
            const errorMsg = await response.json();
            setIsResponse(errorMsg?.message || "Unknown error occurred.");
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          setUGStudents(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setIsResponse("Error fetching examination. Please try again later.");
      }
    };

    fetchData();
  }, [selectedSession, selectedCourse]);
  // -------------------------------------end for fetching student record from ugstudent to add/update marks---------------------

  //-----------------------------------Satrt for fetching marks of stuent record matched the four selection criteria-----------------
  // const [studentFromMarks, setStudentFromMarks] = useState<any>();
  // console.log(studentFromMarks,"studentFromMarks");
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (
          selectedSession &&
          selectedCourse &&
          selectedExam &&
          selectedSubjects
        ) {
          const response = await api.fetchData(
            `/api/all/ug/student/from/marks/${selectedSession}/${selectedCourse}/${selectedExam}/${selectedSubjects}`
          );
          if (response.status !== 200) {
            const errorMsg = await response.json();
            setIsResponse(errorMsg?.message || "Unknown error occurred.");
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          setMarksData(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setIsResponse("Error fetching examination. Please try again later.");
      }
    };
    fetchData();
  }, [selectedSession, selectedCourse, selectedExam, selectedSubjects]);
  //-----------------------------------Satrt for fetching marks of stuent record matched the four selection criteria-----------------

  const [subjectName, setSubjectName] = useState<any>();
  //  console.log(marksData, "marksData");

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (selectedSubjects) {
          const response = await api.fetchData(
            `/api/fetch/subject/name/${selectedSubjects}`
          );
          if (response.status !== 200) {
            const errorMsg = await response.json();
            setIsResponse(errorMsg?.message || "Unknown error occurred.");
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          setSubjectName(response.data[0].subjectName);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setIsResponse("Error fetching examination. Please try again later.");
      }
    };
    fetchData();
  }, [selectedSubjects]);
  // ------------------------Start For fetching all UG students data on selection of Session || Course || Examination || Subject ------------------------

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       if (
  //         selectedSession &&
  //         selectedCourse &&
  //         selectedExam &&
  //         selectedSubjects
  //       ) {
  //         const response = await api.fetchData(
  //           `/api/all/ug/student/fromAttendance/${selectedSession}/${selectedCourse}/${selectedExam}/${selectedSubjects}`
  //         );
  //         if (response.status !== 200) {
  //           const errorMsg = await response.json();
  //           setIsResponse(errorMsg?.message || "Unknown error occurred.");
  //           throw new Error(`HTTP error! Status: ${response.status}`);
  //         }
  //         setUGStudents(response.data.data);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching data:", error);
  //       setIsResponse("Error fetching examination. Please try again later.");
  //     }
  //   };

  //   fetchData();
  // }, [selectedSession, selectedCourse, selectedExam, selectedSubjects]);

  // ------------------------End For fetching all UG students data on selection of Session || Course || Examination || Subject ------------------------

  // Function to handle year selection change
  const handleSessionChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedSession(parseInt(event.target.value));
  };

  const handleCourseChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedCourse(e.target.value);
  };

  const handleExamChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedExam(e.target.value);
  };

  const handleSubjectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedSubjects(e.target.value);
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      setFile(event.target.files[0]);
    }
  };

  const selectedDropdownValue = {
    selectedSession,
    selectedCourse,
    selectedExam,
    selectedSubjects,
  };

  // console.log(file, "FILE VALUE");

  // console.log(ugStudents, "in attendance on filter");

  const {
    user,
    // userLoggedIn, loading, error, userId
  } = useSelector((state: RootState) => ({
    user: state.Auth.user,
    loading: state.Auth.loading,
    error: state.Auth.error,
    userLoggedIn: state.Auth.userLoggedIn,
    userId: state.Auth._id,
  }));
  // const body = [
  //   ["Edison", "Padilla", 14],
  //   ["Cheila", "Rodrigez", 56],
  // ];
  // console.log(body, "body");
  let profileId = user._id ? user._id : user.user ? user.user._id : "";
  //   let Role = user.hobbies ? user.hobbies : user.user.hobbies;
  let profileName = user.name
    ? user.name
    : user.first_name
    ? user.first_name
    : user.user.name;
  //   let subDepartmentName = user.department
  //     ? user.department
  //     : user.user.department;

  const Key_Key = user.moniterd_ttl
    ? user.moniterd_ttl
    : user.user
    ? user.user.moniterd_ttl
    : "";

  const handleFileUpload = async () => {
    if (!file) {
      alert("Please select a file");
      console.error("No file selected.");
      return;
    }
    if (file) {
      try {
        // console.log(file.name, "file selected");
        const formData = new FormData();
        formData.append("excelFile", file);
        formData.append("createdBy", profileId);
        const response = await api.createData(
          `/api/upload/excel/marks`,
          formData
        );
        // console.log("File upload response:", response);
        if (response.status === 440) {
          alert("Session Expired");
          window.location.href = "http://localhost:3004/student/login";
        } else if (response.status === 429) {
          alert("Unknown error");
        } else if (response.status === 400) {
          let errorMessage = await response.message;
          alert(errorMessage);
          console.log(errorMessage, "Error Message");
        }else if (response.status === 500) {
          alert(response.message)
        } else if (response.status === 200 || response.status === 201) {
          alert("Marks successfully Uploaded.");
        }
      } catch (error) {
        alert("Error uploading file");
        console.error("Error uploading file:", error);
      }
    }
  };

  useEffect(() => {
    const mergedData = mergeStudentAttendance(ugStudents, marksData);

    setMergedData(mergedData);
  }, [ugStudents, marksData]);

  const mergeStudentAttendance = (students: any, attendance: any) => {
    const mergedData = students.map((student: any) => {
      const matchedAttendance = attendance.find(
        (record: any) => record.studentId === student._id
      );
      return {
        ...student,
        ...matchedAttendance, // or any specific data you want to merge
      };
    });

    return mergedData;
  };

  //  console.log(mergedData, "mergerdData data````````````````````````");

  const columns = [
    {
      Header: "S.No.",
      accessor: (row: any, index: number) => index + 1,
      sort: true,
    },
    {
      Header: "Enrollment",
      accessor: "enrollment_no",
      sort: true,
    },
    {
      Header: "Name",
      // accessor: "studentName",
      accessor: (row: any) =>
        `${row.first_name} ${row.middle_name} ${row.last_name}`,
      sort: true,
    },
    {
      Header: "Subject",
      // accessor: "subjectName",
      accessor: (row: any, subjectNname: any) => subjectName,
      sort: true,
    },

    {
      Header: "Total Theory Marks",
      accessor: "totalTheoryMarks",
      sort: true,
    },
    {
      Header: "Obtained Theory Marks",
      accessor: "obtainedTheoryMarks",
      sort: false,
    },
    {
      Header: "Total Practical Marks",
      accessor: "totalPracticalMarks",
      sort: false,
    },
    {
      Header: "Obtained Practical Marks",
      accessor: "obtainedPracticalMarks",
      sort: false,
    },
    {
      Header: "Percentage(%)",
      accessor: "percentage",
      sort: true,
    },
    {
      Header: "Add Marks",
      // accessor: "notice_doc",
      // Cell: ({ row }: { row: any }) => (
      //   <AddMarksModal
      //     ugStudent={row.original}
      //     selectedDropdownValue={selectedDropdownValue}
      //     // selectedDate={
      //     //   selectMonth || ugStudents.map((body) => body.attendanceOfMonth)
      //     // }
      //   />
      // ),
      accessor: (row: UGMergedStudentMarksData) => {
        if (
          // row.enrollment_no &&
          // row.studentName &&
          row.totalTheoryMarks &&
          row.obtainedTheoryMarks &&
          row.totalPracticalMarks &&
          row.obtainedPracticalMarks &&
          row.subjectName &&
          row.percentage
        ) {
          return (
            <UpdateMarks
              enrollment_no={row.enrollment_no}
              name={
                row.first_name + " " + row.middle_name + " " + row.last_name
              }
              studentId={row.studentId}
              totalTheoryMarks={row.totalTheoryMarks}
              obtainedTheoryMarks={row.obtainedTheoryMarks}
              totalPracticalMarks={row.totalPracticalMarks}
              obtainedPracticalMarks={row.obtainedPracticalMarks}
              percentage={row.percentage}
              subjectName={row.subjectName}
              subject={subjectName}
              selectedDropdownValue={selectedDropdownValue}
            />
          );
        } else {
          return (
            <AddMarksModal
              enrollment_no={row.enrollment_no}
              name={
                row.first_name + " " + row.middle_name + " " + row.last_name
              }
              id={row._id}
              subjectName={row.subjectName}
              subject={subjectName}
              selectedDropdownValue={selectedDropdownValue}
            />
          );
        }
      },
      sort: false,
    },
  ];
  const sizePerPageList = [
    {
      text: "5",
      value: 5,
    },
    {
      text: "10",
      value: 10,
    },
    {
      text: "25",
      value: 25,
    },
    {
      text: "All",
      value: mergedData?.length,
    },
  ];
  const recordForBody = mergedData?.map((body: any, index: any) => [
    index + 1,
    body?._id,
    selectedSession,
    selectedCourse,
    selectedExam,
    // selectedSubjects,
    body.enrollment_no,
    body?.first_name+" "+body?.middle_name+" "+body?.last_name,
    selectedSubjects,
    body.totalTheoryMarks,
    body.obtainedTheoryMarks,
    body.totalPracticalMarks,
    body.obtainedPracticalMarks,
    body.percentage,
    // body.practicalClassPercentage,
    // body.attendanceOfMonth ? body.attendanceOfMonth : selectMonth,
  ]);
  const dropdownselectedValueForSheet = [
    "StudentId",
    "Session",
    "Course",
    "Examination",
    // "Subjects",
  ];
  const headers = columns.map((headerOnly: any) => headerOnly.Header);
  const headerrr = [
    headers[0],
    ...dropdownselectedValueForSheet,
    ...headers.map((reaming: any) => reaming),
  ];
  const header = headerrr.filter((value, index, array) => {
    return array.indexOf(value) === index;
  });
  header.length = header.length - 1;

  function handleDownloadExcel() {
    if (!selectMonth) {
      downloadExcel({
        fileName: `Students Marks Sheet for ${selectedSession} \n ${selectedCourse} \n ${selectedExam} and ${selectedSubjects} `,
        sheet: "Student Marks Sheet",
        tablePayload: {
          header,
          // accept two different data structures
          body: recordForBody,
        },
      });
    } else {
      alert("please select Month");
    }
  }

  return (
    <>
      <PageTitle
        breadCrumbItems={[
          { label: "UG Marksheet", path: "/page/ug-marksheet" },
          {
            label: "UG Marksheet",
            path: "/page/ug-marksheet",
            active: true,
          },
        ]}
        title={"UG Marksheet"}
      />

      <Row>
        <Col lg={12}>
          <Card>
            <Card.Body>
              <Row className="py-1">
                <Col lg={6} className="mb-2 mb-lg-0">
                  <select
                    className="form-select"
                    value={selectedSession}
                    onChange={handleSessionChange}
                    aria-label="Session"
                  >
                    <option value="">Session</option>
                    {session?.map((session: SessionInfo) => (
                      <option
                        key={session.sessionYear}
                        value={session.sessionYear}
                      >
                        {session.sessionYear}
                      </option>
                    ))}
                  </select>
                </Col>

                <Col lg={6} className="mb-2 mb-lg-0">
                  <select
                    className="form-select"
                    value={selectedCourse}
                    onChange={handleCourseChange}
                    aria-label="Course"
                  >
                    <option value="">Course</option>
                    {courses?.map((course: CourseInfo) => (
                      <option key={course.courseCode} value={course.courseCode}>
                        {course.courseName}
                      </option>
                    ))}
                  </select>
                </Col>
              </Row>

              <Row className="py-1">
                <Col lg={6} className="mb-2 mb-lg-0">
                  <select
                    className="form-select"
                    value={selectedExam}
                    onChange={handleExamChange}
                    aria-label="Examination"
                  >
                    <option value="">Examination</option>
                    {exams?.map((exam: ExamInfo) => (
                      <option key={exam.examCode} value={exam.examCode}>
                        {exam.examName}
                      </option>
                    ))}
                  </select>
                </Col>
                <Col lg={6} className="mb-2 mb-lg-0">
                  <select
                    className="form-select"
                    value={selectedSubjects}
                    onChange={handleSubjectChange}
                    aria-label="Subject"
                  >
                    <option value="">Subject</option>
                    {subjects?.map((subject: SubjectInfo) => (
                      <option
                        key={subject.subjectCode}
                        value={subject.subjectCode}
                      >
                        {subject.subjectName}
                      </option>
                    ))}
                  </select>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <Card>
            <Card.Body>
              <div className="mb-3 pt-2">
                {/* <div className="row" style={{ marginBottom: "0.4rem" }}>
                  <div
                    className="col col-sm-7"
                    style={{ display: "flex", flexDirection: "row" }}
                  >
                    <h5 style={{ marginRight: "4.5rem" }}>
                      <strong>Select Month :</strong>
                      <sup style={{ color: "red" }}>*</sup>{" "}
                    </h5>
                    <input
                      value={selectMonth}
                      type="date"
                      onChange={(e) => setSelectedMonth(e.target.value)}
                    />
                  </div>
                  <div className="col col sm-3">
                    <Button
                      className="btn-sm btn btn-success"
                      onClick={() => setSelectedMonth("")}
                    >
                      <i className="bi bi-bootstrap-reboot"></i>
                    </Button>
                  </div>
                </div> */}
                <div className="">
                  <Button
                    variant="secondary"
                    className="me-1"
                    onClick={handleDownloadExcel}
                    // onClick={downloadExcelSheet}
                  >
                    <i className="bi bi-file-earmark-excel"></i> Download format
                  </Button>
                  <input
                    type="file"
                    accept=".xls,.xlsx"
                    onChange={handleFileChange}
                    style={{
                      padding: "10px 15px",
                      cursor: "pointer",
                      // border: "2px solid #007bff",
                      border: "none",
                      borderRadius: "5px",
                      color: "#007bff",
                      backgroundColor: "transparent",
                      transition: "background-color 0.3s ease",
                    }}
                  />

                  <Button
                    variant="success"
                    className="me-1"
                    onClick={handleFileUpload}
                  >
                    <i className="bi-cloud-upload"></i> Upload Marks
                  </Button>
                </div>
              </div>
              <Table
                columns={columns}
                data={mergedData}
                pageSize={5}
                sizePerPageList={sizePerPageList}
                isSortable={true}
                pagination={true}
                isSearchable={true}
              />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default UGMarksheet;
